import { Component, Input, OnInit } from '@angular/core';
import { LoadConfigService } from '../../services/load-config.service';
import { InstructionModificationService } from '../../services/instruction-modification.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-instruction-container-bg-half',
  templateUrl: './instruction-container-bg-half.component.html',
  styleUrls: ['./instruction-container-bg-half.component.scss'],
})
export class InstructionContainerBgHalfComponent implements OnInit {
  @Input('instruction') instruction: string = 'welcome';
  @Input('route') route: string;
  @Input('label') label: string;
  @Input('section') section: string = null;
  instructions;
  title: string;
  body: string;

  constructor(
    private loadConfigService: LoadConfigService,
    private modifyInstruction: InstructionModificationService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.instructions = this.instructionService.getInstructions('EN');
    this.title = this.instructions[this.instruction]['title'];
    this.replacePlaceholders();

    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm(
        'INSTRUCTION_CONTINUE_BUTTON'
      );
    }
  }

  replacePlaceholders() {
    this.body = this.modifyInstruction.replacePlaceholders(
      this.instructions[this.instruction]['body'],
      this.instruction,
      this.section
    );
  }
}
